import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Button} from 'reactstrap';
import { connect } from 'react-redux';
import api from 'api';
import classnames from "classnames";

class FileUpload extends Component {

  constructor(props) {
    super(props);

    this.state = {
      file: null,
      errors: [],
      loading: false,
      loaded: false
    };

    this.fileUploader = React.createRef();
    this.handleFileSelect = this.handleFileSelect.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.deleteFile = this.deleteFile.bind(this);
  }

  handleFileUpload(file) {
    this.setState({loading: true});
    const formData = new FormData();
    formData.append('file', file);

    api.surveyResponse.postFile(this.props.surveyResponse.id, this.props.question.id, formData)
      .then(path => {
        this.props.handleUpdate(path);
        this.setState({loading: false, loaded: true});
        localStorage.setItem("file-" + this.props.question.id, file.name)
      })
      .catch(res => {
        this.setState({loading: false, errors: [res.response.data.errors[0].message]});
      })
  }

  async handleFileSelect(e) {
    const file = e.target.files[0];
    const errors = [];

    if (file.size / 1000 > this.props.question.fileMaxSize) {
      errors.push('Zbyt duży rozmiar pliku.')
    }

    if (this.props.question.fileExtensions.length > 0 && !this.props.question.fileExtensions.includes(file.name.split('.').pop())) {
      errors.push('Niedozwolony typ pliku.')
    }

    this.setState({errors, file: errors.length === 0 ? e.target.files[0] : null});
    if (errors.length === 0) {
      this.handleFileUpload(e.target.files[0]);
    }
  }

  getFileName(path) {
    if (!path) {
      return localStorage.getItem("file-" + this.props.question.id)
    }

    const split = path.split('/');
    if (split.length > 0) {
      return split[split.length - 1];
    }

    return "";
  }

  deleteFile() {
    api.surveyResponse.deleteFile(this.props.surveyResponse.id, this.props.question.id, this.props.response.filePath)
    .then(res => {
      this.props.handleUpdate("");
      this.setState({loaded: false, loading: false, file: null})
    })
    .catch(res => {
      this.setState({loading: false, errors: [res.response.data.errors[0].message]});
    })
  }

  render() {
    return (
      <div className="answer-area card-body file-upload-container">
        <div className="answer-area card-body">
          <div className={"p-1 file-upload"}>
            <p className={"small color-default"}>Maksymalna wielkość pliku: {this.props.question.fileMaxSize}kb</p>
            {this.props.question.fileExtensions.length > 0 && <p className={"small color-default"}>Dozwolne rozszerzenia plików: {this.props.question.fileExtensions.join(', ')}</p>}
            {!this.props.response.filePath && <button className={classnames({
              "w-100 text-left rounded-button mt-3 mb-3": true
            })}
                onClick={() => !this.state.loading && !this.state.loaded && this.fileUploader.current.click()}>
              <i className="fas fa-arrow-circle-up text-white ml-3 mr-3"/> dodaj plik
            </button>}
            {this.props.response.filePath && <div className={"d-flex"}>
              <button className={classnames({
                "w-100 text-left rounded-button blue mt-3 mb-3 lowercase ellipsis flex-grow-1 mr-2 pe-none": true
              })}>
                <i className="fas fa-circle-check text-white ml-3 mr-3"/> {this.getFileName(this.state.file ? this.state.file.name : "")}
              </button>
              <button className={classnames({
                "w-100 text-left rounded-button exact-width mt-3 mb-3 text-center": true
              })} onClick={this.deleteFile}>
                <i className="fas fa-trash text-white"/>
              </button>
            </div>}
            <input type="file" onChange={this.handleFileSelect} ref={this.fileUploader} hidden={true}/>
            {!!this.state.errors && <p className="small text-danger">{this.state.errors.join(' ')}</p>}
          </div>
        </div>
      </div>
    )
  }
}

FileUpload.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    fileMaxSize: PropTypes.number.isRequired,
    fileExtensions: PropTypes.array.isRequired
  }).isRequired,
  handleUpdate: PropTypes.func.isRequired,
  surveyResponse: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  response: PropTypes.shape({
    filePath: PropTypes.string,
  }).isRequired
};

function mapStateToProps(state) {
  return {
    surveyResponse: state.surveyResponse
  }
}

export default connect(mapStateToProps, null, null, {forwardRef: true, withRef: true})(FileUpload);